/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const ConfigurationKeyR = t.interface({
  config_category: t.string,

  config_key: t.string,

  config_value: t.string
});

// optional attributes
const ConfigurationKeyO = t.partial({
  config_description: t.string
});

export const ConfigurationKey = t.intersection(
  [ConfigurationKeyR, ConfigurationKeyO],
  "ConfigurationKey"
);

export type ConfigurationKey = t.TypeOf<typeof ConfigurationKey>;
